import router from '../../../router'
import * as types from '../../mutation-types'
import * as api from '../../api'

const state = {
  oAuthLoginUrl: '',
  isHavenLockConnected: false
}

const getters = {
  havenLockOAuthLoginUrl: state => state.oAuthLoginUrl
}

const actions = {
  getHavenLockOAuthUrl ({ commit }) {
    return api.instance.get('/haven_lock/authenticate')
      .then(function (response) {
        if (response.status === 200) {
          const havenLockOAuthLoginUrl = response.data.url
          const havenLockOAuthState = response.data.state
          sessionStorage.setItem('oauthstate', havenLockOAuthState)
          commit(types.RECEIVE_HAVENLOCK_OAUTH_URL, havenLockOAuthLoginUrl)
        } else {
          if (response.data.message) { alert('(' + response.status + ') ' + response.data.message) } else { alert('An error occured. Please try again later. (' + response.status + ')') }

          router.push({ name: 'AdminG2Secure' })
        }
      })
      .catch(function (error_msg) {
        if (error_msg) { alert(error_msg) } else { alert('An error occured. Please try again later.') }
      })
  },
  handleAuthHavenLock ({ commit }, authInfo) {
    if (authInfo.authState !== sessionStorage.getItem('oauthstate')) {
      alert('An unexpected error occured. Please try again later.')
      return Promise.resolve().then(function () {
        sessionStorage.removeItem('oauthstate')
        router.push({ name: 'AdminG2Secure' })
      })
    }

    return api.instance.post('/haven_lock/authenticate', authInfo)
      .then(function (response) {
        if (response.status !== 200) {
          if (response.data.message) { alert('(' + response.status + ') ' + response.data.message) } else { alert('An error occured. Please try again later. (' + response.status + ')') }
        }

        sessionStorage.removeItem('oauthstate')
        router.push({ name: 'AdminG2Secure' })
      })
      .catch(function (error_msg) {
        if (error_msg) { alert(error_msg) } else { alert('An error occured. Please try again later.') }
      })
  },
  disconnectHavenLock ({ commit, dispatch }) {
    api.instance.delete('/haven_lock/disconnect')
      .then(function (response) {
        const success = response.data.success
        if (success === 'false') {
          console.log('failure')
        } else {
        // Refresh the settings now that they have changed on the backend.
        // CBTODO -- this is an example of getting too many settings sent back to the client. We don't want to send the client secret.
          dispatch('getPhoenixSettings', 'PHOENIX.FEATURE.G2_SECURE')
          console.log('success')
        }
      }).catch(function () {
        alert('An error occured. Please try again later.')
      })
  },
  loadLocksHavenLock () {
    api.instance.post('/haven_lock/command', { 'command': 'load' })
      .then(function (response) {
        const success = response.data.success
        if (success === 'false') {
          alert('HAVEN locks could not be loaded into G2 Communicator. Please try again later.')
        } else {
          // CBTODO -- tell user the number of locks that were loaded?
          alert('HAVEN locks were loaded into G2 Communicator successfully.')
        }
      }).catch(function () {
        alert('An error occured. Please try again later.')
      })
  },
  commandHavenLock ({}, data) {
    api.instance.post('haven_lock/command', { 'device_id': data['device_id'], 'command': data['command'] })
      .then(function (response) {
        console.log(response)
      }).catch(function () {
        alert('An error occured. Please try again later.')
      })
  }
}

const mutations = {
  [types.RECEIVE_HAVENLOCK_OAUTH_URL] (state, url) {
    state.oAuthLoginUrl = url
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
